import React, { Component } from "react";
import { Row, Container, FormGroup, Label, Input, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import NumberFormat from 'react-number-format';
import "react-toastify/dist/ReactToastify.min.css";
import { ToastContainer, toast } from "react-toastify";
import Loading from "../../shared/components/Loading/Loading";
import requestApi from "../../apirest";
import Switch from "react-switch";
import {  auth } from "../../auth";
import _ from "lodash";
import { getColorsProduct, filterStockByVariant } from "../../services/filter";
import Select from "react-select";

const agencyFee = [
  { value: "motoboy",
    label: "Motoboy"},
  {
    value: "correios",
    label: "Serviços dos Correios",
  },
  { value: "jadlog", label: "Transportadora Jadlog" },
];

const servicesFee = [
  { value: "1",
    label: "Entrega PAC à vista"},
  {
    value: "2",
    label: "Entrega SEDEX à vista",
  },
  {
    value: "3",
    label: "Entrega .Package à vista",
  },{
    value: "4",
    label: "Entrega .Com à vista",
  },
  { value: "0", label: "Motoboy" },
];

class Orderadd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      ErrorMsg: "",
      selectedServiceFee: "",
      selectedAgencyFee: "",
      order: {
        idOrder: null,
        idLink: null,
        products: [],
        userAdmin: null,
        delivery: {
          name: "",
          fee: 0,
          delivery_date: "2020-12-09T12:48:53.017Z",
          expedited: false,
          type : "",
          description: "",
          codeDelivery: "",
        }
      },
      productsList: [],
      productsFiltered: [],
    }
  }


  translateDictionary(key) {
    let dictionary = {
      idOrder: "Id da transação - Pagarme",
      idLink: "Url do link - Pagarme",
      userAdmin: "Id usuário admin",
      description: "Descrição da Ordem",
      paymentMethod: "Método de pagamento",
      ProductPrice: "Preço do produto",
      ProductName: "Código do produto",
      ProductSize: "Tamanho do produto",
      ProductColor: "Cor do produto",
      ProductQuantity: "Quantidade do Produto",
      name: "Nome do cliente",
      street: "Rua",
      street_number: "Número da Rua",
      city: "Cidade",
      state: "Estado",
    }
    return dictionary[key];
  }

  addProduct = (product) => {
    const { order } = this.state;
    const products = order.products;
    const sizes = ["PP", "P", "M", "G", "GG", "XGG"];
    const colors = getColorsProduct(product);
    const productAdd = {
      ProductID: product._id,
      ProductName: product.name,
      ProductImage: "",
      ProductQuantity: 1,
      ProductColor: {},
      stockID: "",
      variantID: "",
      ProductPrice: product.price,
      ProductSize: "",
      ProductNew: product.new,
      ProductSale: product.sale,
      ProductSalePrice: product.salePrice,
      colors,
      sizes,
      variants: product.variants,
    };
    products.push(productAdd);
    this.setState({ order });
  };

  deleteNewVariant = (e) => {
    const { order } = this.state;
    order.products.splice(e, 1);

    this.setState({ order });
  };

  handleOrderProduct = (e, index) => {
    const { name, value } = e.target;
    const { order } = this.state;

    const product = order.products[index];
    product[name] = value;
    this.setState({ order });
  };

  handleOrderFee = (obj) => {
    let { order } = this.state;
    const { floatValue } = obj;
    if (floatValue) {
      const number = floatValue;
      order.delivery.fee = number;

      let totalAmount = order.products.reduce(
        (accumulator, product) =>
          accumulator +
          product.ProductQuantity *
            (product.ProductSale
              ? product.ProductSalePrice
              : product.ProductPrice),
        0
      );

      order.amount = totalAmount + order.delivery.fee;
      order.paidAmount =
        totalAmount + order.delivery.feetotalAmount + order.delivery.fee;
    }
    this.setState({ order });
  };

  findProductsByTerm = async (searchTerm) => {
    let { productsList, productsFiltered } = this.state;

    if (searchTerm.length >= 4) {
      if (_.isEmpty(productsList)) {
        productsList = await this.findProductList();

      }
      productsFiltered = _.filter(productsList, function (product) {
        return (
          product.code
            .toUpperCase()
            .includes(searchTerm.toString().toUpperCase()) ||
          product.name
            .toUpperCase()
            .includes(searchTerm.toString().toUpperCase())
        );
      });

      this.setState({ productsFiltered });
    }
  };

  findProductList = async () => {
    let { productList } = this.state;
    this.setState({ loading: true });

    try {
      let resp = await requestApi(`/products`, {}, "get");
      productList = resp.data.doc;
      this.setState({ loading: false, productList });
      return productList;
    } catch (error) {
      toast.error("Aconteceu algum erro inesperado.", {
        autoClose: 4000,
      });
      this.setState({ loading: false });
    }
  };

  changeVariant = async (item, index) => {
    this.setState({ loading: true });
    let { order } = this.state;

    let productIndex = order.products[index];

    _.forEach(productIndex.variants, function (variantColor) {
      if (variantColor._id === item.idVariant) {
        productIndex.variantID = item.idVariant;
        productIndex.ProductImage = variantColor.pictures[0].url;
        productIndex.variant = variantColor;
        productIndex.ProductColor.color = variantColor.color.hex;
        productIndex.ProductColor.idVariant = item.idVariant;
        productIndex.ProductColor.colorName = variantColor.colorName;
      }
    });

    await this.changeStockQuantity(productIndex);

    this.setState({ order, loading: false });
  };


  changeStockQuantity = async (productIndex) => {
    const resp = await this.findStockForOriginAndVariant(productIndex.variant);
    const { total, stock } = resp.data;
    console.log(resp);
    if (total > 0) {
      productIndex.variant.stock = stock;
      this.changeStockQuantityForSize(productIndex, stock);
      productIndex.hasStock = true;
    } else {
      productIndex.hasStock = false;
      toast.error(this.getMessageErrorNoStock(), {
        autoClose: 4000,
      });
    }
  }

  findStockForOriginAndVariant = async (variant) => {
    return await requestApi(`/stocks?variantId=${variant._id}`, {}, "get");
  }

  changeStockQuantityForSize = (productIndex, stocks) => {
    _.forEach(stocks, function (stock) {
      if (productIndex.ProductSize === stock.size) {
        productIndex.stockQuantity = stock.quantity;
      }
    })
  }

  changeStock = (sizeChoose, index) => {
    let { order } = this.state;

    let productIndex = order.products[index];
    _.forEach(productIndex.variant.stock, function (stock) {
      if (stock.size === sizeChoose) {
        productIndex.stockID = stock._id;
        productIndex.ProductSize = sizeChoose;
      }
    });

    this.setState({ order });
  };



  async findUser(userAuth) {
    this.setState({ loading: true });
    const  {order} = this.state;
    try {
        if (userAuth) {
          let user = await requestApi(`/users/findById`, { idAuth: userAuth }, "get", "user");
          order.userAdmin = user.data.doc._id;
          this.setState({
            loading: false,
            user: user.data.doc,
            order

          });
        } else {
          toast.error("Não foi possível recuperar o usuário", {
            autoClose: 4000,
          });
          this.setState({
            user: null,
            loading: false,
          });
        }
    } catch (error) {
      toast.error("Erro ao recuperar usuário", {
        autoClose: 4000,
      });
      this.setState({
        loading: false,
      });
    }
  }


  handleOrderServiceFee= (selectedServiceFee) => {
    let { order } = this.state;
    order.delivery.codeDelivery = selectedServiceFee.value;
    order.delivery.description = selectedServiceFee.label;
    this.setState({ order, selectedServiceFee });
  };

  handleOrderChecked = (checked, index) => {
    let { order } = this.state;
    order.products[index].ProductSale = checked;
    this.setState({ order });
  };

  handleOrderAgencyFee= (selectedAgencyFee) => {
    let { order } = this.state;
    order.delivery.type = selectedAgencyFee.value;
    this.setState({ order, selectedAgencyFee });
  };

  findCouponById = async (idCoupon) => {
    let { order } = this.state;
    this.setState({ loading: true })

    try {
      let resp = await requestApi('/coupons/findById', idCoupon, "get");
      toast.success("As informações foram carregadas com sucesso.", {
        autoClose: 4000,
      });
      order = resp.data.doc;
      this.setState({ loading: false, order })
    } catch (error) {
      toast.error("Aconteceu algum erro inesperado.", {
        autoClose: 4000,
      });
      this.setState({ loading: false })
    }
  };


  async componentDidMount() {
    const idCoupon = (this.props.location && this.props.location.state && this.props.location.state.idProduct) || null;


    try {

      auth.onAuthStateChanged( async user => {

        if (user) {
          this.setState({ user, loading: false });
          this.findUser(user.uid);
        } else {
          this.setState({ loading: false });
        }
      });
    } catch (error) {
      throw error;
    }

    if (idCoupon) {
      await this.findCouponById(idCoupon);
    }
    window.scrollTo(0, 0);
  }



  handleOrder = e => {
    const { name, value } = e.target;

    this.setState(prevState => ({
      order: {
        ...prevState.order,
        [name]: value
      }
    }));
  };

  handleProductPrice = (obj, key, index) => {
    let { order } = this.state;
    const { floatValue } = obj;
    if (floatValue) {
      const number = floatValue;
      const variant = order.products[index];
      variant[key] = number;

      let totalAmount = order.products.reduce(
        (accumulator, product) =>
          accumulator +
          product.ProductQuantity *
            (product.ProductSale
              ? product.ProductSalePrice
              : product.ProductPrice),
        0
      );

      order.amount = totalAmount + order.delivery.fee;
      order.paidAmount =
        totalAmount + order.delivery.feetotalAmount + order.delivery.fee;
    }
    this.setState({ order });
  };

  requiredFieldsProducts = (key) => {
    let dictionary = {
      ProductPrice: "Preço do produto",
      ProductName: "Código do produto",
      ProductSize: "Tamanho do produto",
      ProductColor: "Cor do produto",
      ProductQuantity: "Quantidade do Produto",
    };
    return dictionary[key] ? true : false;
  };

  requiredFields = (key) => {
    let dictionary = {
      idOrder: "Id da transação - Pagarme",
      userAdmin: "Id usuário admin",
    }
    return dictionary[key] ? true : false;
  }

  validateOrder = () => {
    const { order } = this.state;
    let isValidate = true;

    Object.keys(order).forEach(key => {
      let requiredField = this.requiredFields(key);
      if (!order[key] && requiredField) {
        isValidate = false;
        toast.warning("O campo " + this.translateDictionary(key) + " é obrigatório.", {
          autoClose: 4000,
        })
      }
    });

    if(_.isEmpty(order.products)){
      isValidate = false;
      toast.warning(
        "Não foi adicionado nenhum produto",
        {
          autoClose: 4000,
        }
      );
    }

    for (const product of order.products) {
      Object.keys(product).forEach((key) => {
        let requiredField = this.requiredFieldsProducts(key);
        if (!product[key] && requiredField) {
          isValidate = false;
          toast.warning(
            "O campo " + this.translateDictionary(key) + " é obrigatório.",
            {
              autoClose: 4000,
            }
          );
        }
      });
    }

    return isValidate;
  }

  clearAddProducts = () => {
    let { order } = this.state;
    if (order?.products) {
      order.products.splice(0, order.products.length)
    }
  }

  getMessageErrorNoStock() {
    return 'Não existe estoque para esse produto!';
  }

  addOrder = async () => {
    const { order } = this.state;
    this.setState({ loading: true })

    try {
      if (this.validateOrder()) {
        if (order._id) {
          await requestApi(`/coupons`, { order }, "patch");
        } else {
          console.log(order);
          await requestApi(`/services/pagarme/createOrderByAdmin`, { order }, "post");
        }
        toast.success("As informações foram atualizadas com sucesso.", {
          autoClose: 4000,
        });
      }
      this.setState({ loading: false })
    } catch (error) {
      toast.error("Aconteceu algum erro inesperado.", {
        autoClose: 4000,
      });
      this.setState({ loading: false })
    }

  };



  render() {
    const { order, loading, productsFiltered } = this.state;

    return (
      <div>
        <ToastContainer />
        <div className="site-content">
          <div className="content-wrapper pt-6 pb-6">
            <Container>
              <div className="col-6">
                <Row>


                  <div className="product-top-right col-12">
                    <div className="product-top-right-inner">
                      <div className="summary entry-summary">
                        <FormGroup className="edit-icon"><h6>Adicionar Venda by Link </h6></FormGroup>

                        <Row>

                        <div className="col-6">
                            <FormGroup className="edit-icon">
                              <Label>Venda por link:</Label>
                            </FormGroup>
                          </div>


                          <div className="col-12">
                            <FormGroup className="edit-icon mt-4">
                              <h6>Carrinho de Compras:</h6>
                            </FormGroup>

                            <FormGroup className="edit-icon">
                              <Label>Digite o produto:</Label>
                              <input
                                type="text"
                                className="form-control description"
                                placeholder="Digite o produto:"
                                onChange={(e) =>
                                  this.findProductsByTerm(e.target.value)
                                }
                              />
                              <div className="col-12 mt-2">
                                <table class="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th scope="col"></th>
                                      <th scope="col">Código</th>
                                      <th scope="col">Nome</th>
                                      <th scope="col">Selecionar</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {productsFiltered.map((product) => (
                                      <>
                                        <tr>
                                          <td className="ordered-image">
                                            <div className="product-thumbnail-main">
                                              <img
                                                src={
                                                  product &&
                                                  product.variants &&
                                                  product.variants[0]
                                                    .pictures[0].url
                                                }
                                                className="img-fluid-cart"
                                              />
                                            </div>
                                          </td>
                                          <td>{product.code}</td>
                                          <td>{product.name}</td>
                                          <td>
                                            <button
                                              onClick={() =>
                                                this.addProduct(product)
                                              }
                                              type="button"
                                              class="btn btn-primary mt-2"
                                            >
                                              Adicionar Produto
                                            </button>
                                          </td>
                                        </tr>
                                      </>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </FormGroup>

                            {order.products.map((product, index) => {
                              return (
                                <>
                                  <FormGroup className="edit-icon mt-4">
                                    <div className="mb-1 d-flex justify-content-end">
                                      <div className="col-12">
                                        <h6 className="col-8 float-left">
                                          {product.ProductName} - Item {index}:
                                        </h6>
                                        <button
                                          onClick={() =>
                                            this.deleteNewVariant(index)
                                          }
                                          type="button"
                                          className="delete-variation mt-2 col-4 float-right"
                                        >
                                          x
                                        </button>
                                      </div>
                                    </div>
                                  </FormGroup>
                                  <div className="col-12 ml-3">
                                    <FormGroup className="edit-icon">
                                      <Label>Cor:</Label>
                                      <Row className="mb-2 ml-1">
                                        {product.colors.map((item) =>
                                         item.idVariant ===
                                         product.variantID ? (
                                            <div
                                              className="circle-color-active ml-2"
                                              style={{
                                                backgroundImage: `url(${item.colorImage})`,
                                                backgroundPosition: 'center',
                                              }}
                                              onClick={() => this.changeVariant(item,index)}
                                            ></div>
                                          ) : (
                                            <div
                                              className={'circleColor ml-2 '}
                                              style={{
                                                backgroundImage: `url(${item.colorImage})`,
                                                backgroundPosition: 'center',
                                              }}
                                              onClick={() => this.changeVariant(item,index)}
                                            ></div>
                                          )
                                        )}
                                      </Row>
                                    </FormGroup>

                                    {product.variant && product.hasStock ? (
                                      <FormGroup className="edit-icon">
                                        <Label>Tamanho:</Label>
                                        <Row className="mb-2 ml-1">
                                          {product.sizes.map((size) =>
                                            size === product.ProductSize ? (
                                              <div
                                                className="circle-size-active ml-2"
                                                onClick={() =>
                                                  this.changeStock(size, index)
                                                }
                                              >
                                                {size}
                                              </div>
                                            ) : (
                                              <div
                                                className="circleSize ml-2"
                                                onClick={() =>
                                                  this.changeStock(size, index)
                                                }
                                              >
                                                {size}
                                              </div>
                                            )
                                          )}
                                        </Row>
                                      </FormGroup>
                                    ) : (
                                      ""
                                    )}

                                    {product.hasStock ? (
                                      <FormGroup className="edit-icon">
                                        <Label>Quantidade no estoque: {order.products[index].stockQuantity}</Label>
                                      </FormGroup>
                                    ) : product.variant && !product.hasStock ?
                                      (<Label className="label-required-fields">{this.getMessageErrorNoStock()}</Label>)
                                      : ("")}

                                    <FormGroup className="edit-icon">
                                      <Label>Preço:</Label>
                                      <NumberFormat
                                        decimalSeparator=","
                                        prefix="R$"
                                        thousandSeparator="."
                                        inputType="number"
                                        decimalScale="2"
                                        fixedDecimalScale={true}
                                        className="form-control description"
                                        placeholder="Preço"
                                        onValueChange={(e) =>
                                          this.handleProductPrice(
                                            e,
                                            "ProductPrice",
                                            index
                                          )
                                        }
                                        value={
                                          order.products[index].ProductPrice
                                        }
                                      />
                                    </FormGroup>

                                    <FormGroup className="edit-icon">
                                      <Label>Quantidade:</Label>
                                      <Input
                                        type="number"
                                        className="form-control description"
                                        placeholder="Quantidade"
                                        name="ProductQuantity"
                                        onChange={(e) =>
                                          this.handleOrderProduct(e, index)
                                        }
                                        value={
                                          order.products[index].ProductQuantity
                                        }
                                      />
                                    </FormGroup>

                                    <FormGroup className="edit-icon">
                                      <Label>Desconto:</Label>
                                      <Switch
                                        checked={
                                          order.products[index].ProductSale
                                        }
                                        onChange={(checked) =>
                                          this.handleOrderChecked(
                                            checked,
                                            index
                                          )
                                        }
                                        onColor="#86d3ff"
                                        onHandleColor="#2693e6"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 7px rgba(0, 0, 0, 0.2)"
                                        height={12}
                                        width={28}
                                        className="react-switch mt-2"
                                        id="material-switch"
                                      />
                                    </FormGroup>

                                    {product.ProductSale ? (
                                      <FormGroup className="edit-icon">
                                        <Label>Preço com Desconto:</Label>
                                        <NumberFormat
                                          decimalSeparator=","
                                          prefix="R$"
                                          thousandSeparator="."
                                          inputType="number"
                                          decimalScale="2"
                                          fixedDecimalScale={true}
                                          className="form-control description"
                                          placeholder="Preço"
                                          onValueChange={(e) =>
                                            this.handleProductPrice(
                                              e,
                                              "ProductSalePrice",
                                              index
                                            )
                                          }
                                          value={
                                            order.products[index]
                                              .ProductSalePrice
                                          }
                                        />
                                      </FormGroup>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </>
                              );
                            })}
                          </div>

                          <div className="col-6">
                            <FormGroup className="edit-icon mt-4">
                              <h6>Resumo da Venda:</h6>
                            </FormGroup>

                            <FormGroup className="edit-icon col-12 float-left">
                              <Label>Tipo de envio:</Label>
                              <Select
                                value={this.state.selectedAgencyFee}
                                onChange={this.handleOrderAgencyFee}
                                options={agencyFee}
                              />
                            </FormGroup>

                            <FormGroup className="edit-icon col-12 float-left">
                              <Label>Tipo de envio:</Label>
                              <Select
                                value={this.state.selectedServiceFee}
                                onChange={this.handleOrderServiceFee}
                                options={servicesFee}
                              />
                            </FormGroup>

                            <FormGroup className="edit-icon">
                              <Label>Valor do frete:</Label>
                              <NumberFormat
                                decimalSeparator=","
                                prefix="R$"
                                thousandSeparator="."
                                inputType="number"
                                decimalScale="2"
                                fixedDecimalScale={true}
                                onValueChange={(e) => this.handleOrderFee(e)}
                                className="form-control description"
                                placeholder="Valor do Frete"
                                value={order.delivery.fee}
                              />
                            </FormGroup>

                            <FormGroup className="edit-icon">
                              <Label>Valor TOTAL:</Label>
                              <NumberFormat
                                decimalSeparator=","
                                prefix="R$"
                                thousandSeparator="."
                                inputType="number"
                                decimalScale="2"
                                fixedDecimalScale={true}
                                disabled={true}
                                className="form-control description"
                                placeholder="Valor Total"
                                value={order.amount}
                              />
                            </FormGroup>

                            <FormGroup className="edit-icon">
                            <Label>Id da transação Pagarme:</Label>
                          <Input
                            type="text"
                            className="form-control description"
                            placeholder="Id transação - Pagarme"
                            name="idOrder"
                            onChange={e => this.handleOrder(e)}
                            value={order.idOrder}
                          />
                        </FormGroup>



                        <button
                          type="button"
                          onClick={() => this.addOrder()}
                          class="btn btn-primary mt-5 mr-2"
                        >
                          Salvar
                        </button>
                        <Link
                          to="/admin-panel/Product"
                          class="btn btn-danger mt-5"
                        >
                          Cancelar
                        </Link>

                          </div>
                        </Row>


                      </div>
                    </div>
                  </div>
                </Row>
              </div>
            </Container>
          </div>
          {loading && <Loading overlay />}
        </div>
      </div>
    );
  }
}
export default Orderadd;
